import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { svgIconList } from '@shared/svg-icon-list';
import { PortalMemberProfileHttpService } from '@core/services/portal-member-profile-http.service';

@Component({
  selector: 'app-floating-reward',
  imports: [CommonModule, TranslateModule, SafeHtmlPipe],
  templateUrl: './floating-reward.component.html',
  styleUrls: ['./floating-reward.component.scss']
})
export class FloatingRewardComponent implements OnInit {
  
  svg: any = svgIconList;

  minimizeDialog = true;
  showBallon = false;
  isSuccess: any;
  rewardsData: any = null;
  disabledButton = false;

  constructor(
    private profileService: PortalMemberProfileHttpService,
    private router: Router,
    private eventEmitterService: EventEmitterService,
  ) {
  }

  ngOnInit() {
    this.isSuccess = this.profileService.isSuccess;
    this.onGetRewardDetails();
    this.eventEmitterService.updateRewardBubbleEmitter.subscribe(() => {
      this.onGetRewardDetails();
    });
  }

  onTogglePopup(forceExpand: boolean = false) {
    this.minimizeDialog = forceExpand ? false : !this.minimizeDialog;
    this.setRequestDialog()
    if (this.rewardsData == null) this.minimizeDialog = true;
    if (this.rewardsData.show_reward == 1 && this.rewardsData.pending_reward > 0) {
      this.showBallon = true;
    } else {
      this.showBallon = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  setRequestDialog(event?: any) {
    var requestDialog = document.getElementById('rewards-dialog');
    var ballon = document.getElementsByClassName('rewards-floating-content')[0].getBoundingClientRect();
    var ballonWrapper = document.getElementById('rewards-floating-bubble');

    if (this.minimizeDialog) {
      requestDialog.style.top = ballon.top - (requestDialog.offsetHeight / 2) + 'px'
      requestDialog.style.left = ballon.left - (requestDialog.offsetWidth / 2) + 'px';
    } else {
      requestDialog.style.top = (window.innerHeight - requestDialog.offsetHeight) / 2 + 'px';
      requestDialog.style.left = (window.innerWidth - requestDialog.offsetWidth) / 2 + 'px';
      // ballonWrapper.style.left = '15px';
    }
  }

  onRedirect(){
    this.onTogglePopup();
    this.router.navigateByUrl('/member/rewards');
  }

  onGetRewardDetails(){
    this.profileService.getRewardDetails().pipe(
      tap(res => {
        this.rewardsData = res;
        if (this.rewardsData.show_reward == 1 && this.rewardsData.pending_reward > 0) {
          this.showBallon = true;
        } else if (this.rewardsData.pending_reward == 0) {
          this.showBallon = false;
        }
      }),
    ).subscribe();

  }

  onNotShowAgain(e: Event) {
    this.disabledButton = true;
    const checked = (e.target as HTMLInputElement).checked ? 0 : 1; 
    const data = {
      show_reward: checked,
    };
    this.profileService.updateShowRewards(data).pipe(
      tap(res => {
        this.isSuccess = this.profileService.isSuccess;
        this.onGetRewardDetails();
        this.disabledButton = false;
      }),
      catchError((err) => {
        this.disabledButton = false;
        return err;
      })
    ).subscribe();
  }

}
